import { render, staticRenderFns } from "./MailRegistrationVerification.vue?vue&type=template&id=7cc460d0&"
import script from "./MailRegistrationVerification.vue?vue&type=script&lang=js&"
export * from "./MailRegistrationVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports